import styled from "styled-components";
import { palette } from "styled-theme";
import { withFilteredProps } from '@components/withFilteredProps/withFilteredProps';

const shouldForwardProp = (prop) => !['removeOutline'].includes(prop);

const _UnStyledButton = styled.button.attrs(({type = "button"}) => ({
  type, // default TextButton to be button instead of submit
}))`
  text-align: left;
  text-decoration: none;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  user-select: text;
  -moz-user-select: text;
  cursor: pointer;
  outline: none;
  font-size: 15px;
  font-weight: 800;
  ${props => props.removeOutline ? "outline: none" : ""};
  background-color: ${palette("color", 15)};
  border-radius: 25px;
  
  .button-text-color {
      color: ${palette("color", 16)};
  }

  &:hover {
    background-color: ${palette("color", 30)};

    .button-text-color {
      color: ${palette("color", 15)};
    }
  }
  
  &:disabled {
    cursor: default;
  }
`;

export const UnStyledButton = withFilteredProps(_UnStyledButton, shouldForwardProp);

export const TextButton = styled(UnStyledButton)`
  color:${palette("link", 1)};
  text-decoration: underline;
  
  &:hover {
    color:${palette("link", 0)};
    text-decoration: none;
  }
`;